import {useEffect, useState} from "react";
import {Box, Container} from "@mui/material";
import i18n from "i18next";

const ShippingConditions = () => {
    const [content, setContent] = useState<string>('');


    useEffect(() => {
        const updateContent = (lng: string) => {
            const file = lng === 'de' ? '/shippingConditions_de.html' : '/shippingConditions_en.html';
            fetch(file)
                .then((res) => res.text())
                .then((html) => setContent(html));
        };

        // Initial load
        updateContent(i18n.language);

        i18n.on('languageChanged', updateContent);

        return () => {
            i18n.off('languageChanged', updateContent);
        };
    }, []);

    return (
        <Container maxWidth="md" sx={{my: 4}}>
            <Box
                sx={{
                    fontSize: '1rem',
                    lineHeight: 1.7,
                    '& h4': {mt: 3, mb: 1},
                    '& p': {mb: 2},
                }}
                dangerouslySetInnerHTML={{__html: content}}
            />
        </Container>
    )
}

export default ShippingConditions